import axios from 'axios';

export class ProjectsQueryApi {
  public static async getClientEnvironment(
    clientEnvironmentId: number
  ): Promise<ClientEnvironment> {
    const endpoint = `${process.env.NEXT_PUBLIC_API_BASE_PATH}/cast_proj/clientEnvironment/${clientEnvironmentId}`;
    try {
      const response = await axios.get(endpoint);
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
